import { IconWrapper } from '../runtime';
export default IconWrapper('dbs_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#00A692"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 14H16C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14Z",
      "fill": "#009080"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 14H16C16 15.1046 15.1046 16 14 16H8V14Z",
      "fill": "#0BBEA8"
    }
  }), h("path", {
    "attrs": {
      "d": "M5.73536 3L1.5 4.37624L3.04665 6.31687L7.28201 4.94063L8.82866 6.88126L13.064 5.50502L11.5174 3.56439L7.28201 4.94063L5.73536 3Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M7.17134 7.41979L2.93598 8.79602L4.48263 10.7367L8.71799 9.36041L10.2646 11.301L14.5 9.9248L12.9534 7.98417L8.71799 9.36041L7.17134 7.41979Z",
      "fill": "white"
    }
  })]);
});